import $ from 'jquery';

export class HiddenArea {

  constructor($el) {

    this.$area = $el;

    this.opts = HiddenArea.defaults;
    this.opts.uid = this.k2UID;
    this.opts.id = this.$area.attr('id');

    this.isOpen = false;

    this.$triggers = $('.js-hidden-area-trigger[data-target="#' + this.$area.attr('id') + '"]');
    this.$area.hide();
    this.setEvents();
  }

  setEvents() {
    this.$triggers.click(() => {
      this.toggleArea();

      return false;
    });
  }

  toggleArea() {
    this.$triggers.toggleClass('hidden');

    this.isOpen = !this.isOpen;

    if (this.isOpen) {
      this.$area.slideDown();
    } else {
      this.$area.slideUp();
    }
  }

}

HiddenArea.defaults = {};

export default function hiddenArea($hiddenArea = $('.js-hidden-area')) {
  if ($hiddenArea && $hiddenArea.length && !$hiddenArea.data('hiddenArena')) {
    $hiddenArea.each(function () {
      $hiddenArea.data('hiddenArena', new HiddenArea($(this)));
    });
  }
}



// WEBPACK FOOTER //
// ./front/bankomania/js/modules/hiddenArea.js